class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    document.getElementById('ProductGridContainer').querySelector('.collection-grid-container').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    /* BRANDSETS: zachowaj ORYGINALNY węzeł paska filtrów (stan otwartych grup,
       przewinięcie i listenery zostają). Zawartość grup (.js-filter) aktualizuje
       renderFilters, więc świeży sidebar z serwera nie jest potrzebny. */
    const sidebarPrev = document.querySelector('.collection__facets--sidebar');
    const sidebarScroll = sidebarPrev ? sidebarPrev.scrollTop : 0;

    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    if (sidebarPrev) {
      const sidebarNew = document.querySelector('.collection__facets--sidebar');
      if (sidebarNew && sidebarNew !== sidebarPrev) {
        sidebarNew.replaceWith(sidebarPrev);
        sidebarPrev.scrollTop = sidebarScroll;
      }
    }

    /* BRANDSETS: po podmianie siatki odśwież stan przełącznika dostępności */
    if (typeof window.bsAvailSync === 'function') window.bsAvailSync();
  }

  static renderProductCount(html) {
    const sourceCount = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    if (!sourceCount) return;
    const count = sourceCount.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
    const facetDetailsElementsFromDom = document.querySelectorAll('#FacetFiltersForm .js-filter');

    // Remove facets that are no longer returned from the server
    // (BRANDSETS: usuwamy całą grupę <details>, żeby nie zostawały puste sekcje)
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        const parentSection = currentElement.closest('details.facets__accordion-section');
        (parentSection || currentElement).remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      /* BRANDSETS: aktualizujemy WSZYSTKIE kopie grupy (drawer mobilny + sidebar) */
      const matchingElements = document.querySelectorAll('.js-filter[id="' + elementToRender.id + '"]');
      if (matchingElements.length) {
        matchingElements.forEach((el) => {
          el.innerHTML = elementToRender.innerHTML;
        });
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementToActivate = newFacetDetailsElement ? newFacetDetailsElement.querySelector('.facets__summary') : null;

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }

    /* BRANDSETS: serwer nie wie o trybie "tylko od ręki" (parametr bs), więc
       po przerysowaniu filtrów przywracamy właściwy stan przełącznika */
    if (typeof window.bsAvailSync === 'function') window.bsAvailSync();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }


onSubmitHandler(event) {
  event.preventDefault();
  const sortFilterForms = document.querySelectorAll('facet-filters-form form');

  const params = new URLSearchParams();

  sortFilterForms.forEach((form) => {
    const formParams = new URLSearchParams(this.createSearchParams(form));
    formParams.forEach((value, key) => {
      // Use set to update only the 'price' parameters with the latest value
      if (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') {
        params.set(key, value); // Update price parameters with the latest value
      } else if (key === 'filter.v.availability' || key === 'bs') {
        // BRANDSETS: bez duplikatów (formularz drawera i sidebara mają te same ukryte pola)
        if (params.getAll(key).indexOf(value) === -1) params.append(key, value);
      } else {
        params.append(key, value); // Append other parameters as usual
      }
    });
  });

  this.onSubmitForm(params.toString(), event);
}
  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    const allowedKeys = ['Backspace', 'Tab', 'Enter', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Delete', 'Escape'];
    if (!allowedKeys.includes(event.key) && !/[0-9.,]/.test(event.key)) {
      event.preventDefault();
    }
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (maxInput.value) {
      minInput.setAttribute('data-max', maxInput.value);
    } else {
      minInput.setAttribute('data-max', maxInput.getAttribute('max'));
    }

    if (minInput.value) {
      maxInput.setAttribute('data-min', minInput.value);
    } else {
      maxInput.setAttribute('data-min', minInput.getAttribute('min'));
    }
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min')) || 0;
    const max = Number(input.getAttribute('max'));

    if (!isNaN(min) && value < min) input.value = min;
    if (!isNaN(max) && value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/* ═══ BRANDSETS: przełącznik dostępności ═══
   dostepne   - domyślny: wszystko oprócz wyprzedanych (też na zamówienie)
   odreki     - to samo zapytanie + ukrycie kafelków oznaczonych jako na zamówienie
   wyprzedane - tylko całkiem wyprzedane
   wszystkie  - bez ograniczeń
   Tryb "odreki" żyje w adresie jako bs=odreki (Liquid go nie widzi, więc ukrywanie
   robi ten skrypt - dzięki temu stronicowanie i wyniki Shopify zostają nienaruszone). */
(function () {
  if (window.__bsAvailInit) return;
  window.__bsAvailInit = true;

  function stateFromUrl() {
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.get('bs') === 'odreki') return 'odreki';
      var av = u.searchParams.getAll('filter.v.availability');
      if (av.indexOf('1') !== -1 && av.indexOf('0') !== -1) return 'wszystkie';
      if (av.indexOf('0') !== -1) return 'wyprzedane';
      return 'dostepne';
    } catch (e) {
      return 'dostepne';
    }
  }

  function inputsFor(state) {
    var av1 = '<input type="hidden" name="filter.v.availability" value="1">';
    var av0 = '<input type="hidden" name="filter.v.availability" value="0">';
    if (state === 'wyprzedane') return av0;
    if (state === 'wszystkie') return av1 + av0;
    if (state === 'odreki') return av1 + '<input type="hidden" name="bs" value="odreki">';
    return av1;
  }

  function paint(state) {
    document.querySelectorAll('[data-avail-root]').forEach(function (root) {
      root.querySelectorAll('[data-avail-radio]').forEach(function (radio) {
        radio.checked = radio.value === state;
        var item = radio.closest('.facets__item');
        if (item) item.classList.toggle('facets__item--checked', radio.checked);
      });
      var jsFilter = root.closest('.js-filter');
      if (!jsFilter) return;
      var holder = jsFilter.querySelector('[data-avail-hidden]');
      if (holder) holder.innerHTML = inputsFor(state);
    });

    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var hidden = 0;
    grid.querySelectorAll('product-card').forEach(function (card) {
      var isPreorder = !!card.querySelector('[data-bs-preorder]');
      var hide = state === 'odreki' && isPreorder;
      card.style.display = hide ? 'none' : '';
      if (hide) hidden++;
    });

    var note = document.getElementById('BsOdRekiNote');
    if (note) {
      var visible = grid.querySelectorAll('product-card').length - hidden;
      if (state === 'odreki' && visible === 0) {
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }
  }

  window.bsAvailSync = function () { paint(stateFromUrl()); };

  document.addEventListener('change', function (event) {
    var radio = event.target && event.target.closest ? event.target.closest('[data-avail-radio]') : null;
    if (!radio) return;
    paint(radio.value);
  });

  /* przyciski przy pustym wyniku */
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var showAll = t.closest('[data-avail-show-all]');
    var back = t.closest('[data-avail-back]');
    if (!showAll && !back) return;
    var u = new URL(window.location.href);
    u.searchParams.delete('filter.v.availability');
    u.searchParams.delete('bs');
    u.searchParams.append('filter.v.availability', '1');
    if (showAll) u.searchParams.append('filter.v.availability', '0');
    window.location.href = u.href;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.bsAvailSync);
  } else {
    window.bsAvailSync();
  }
})();
